<template>
  <div class="items-center pt-1.5 justify-center flex flex-col">
    <img
      v-show="$store.state.currentComponent == this.title"
      alt="icon"
      class="mb-0.5 h-5 w-5 object-contain"
      :src="iconActive"
    />
    <img
      v-show="$store.state.currentComponent != this.title"
      alt="icon"
      class="mb-0.5 h-5 w-5 object-contain"
      :src="iconInactive"
    />
    <p
      :class="{
        'text-bnb-brown font-bold tracking-wider text-sm':
          $store.state.currentComponent == title,
      }"
      class="text-xs font-medium shadow-md"
    >
      {{ title }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    iconActive: String,
    iconInactive: String,
  },
};
</script>
